export default {
    menu: {
        Dashboard: 'Dashboard',
        DashboardV2: 'Dashboard V2',
        DashboardV3: 'Dashboard V3',
        Partners: 'Parceiros',
        Leads: 'Prospects',
        Customers: 'Clientes',
        Bills: 'Faturas',
        Marketing: 'Marketing',
        Reports: 'Relatórios',
        Commissions: 'Comissões',
        Settings: 'Config. Geral',
        Logs: 'Logs',
        Products: 'Produtos',
        Categories: 'Categorias',
    },

    children: {
        Marketing: {
            Files: 'Materiais de Apoio',
            'Landing Pages': 'Páginas de Captação',
        },

        Products: {
            Products: 'Produtos',
            Sales: 'Vendas',
        },

        Reports: {
            Bills: 'Faturas',
            Bookings: 'Bookings',
            Resellers: 'Parceiros',
        },

        Commissions: {
            'commission-partners': 'Comissões Parceiros',
            'commission-categories': 'Categorias',
            Taxes: 'Taxas/Imposto',
            'commission-config': 'Configurações',
        },

        Settings: {
            Plans: 'Planos',
            'Plan Packages': 'Pacotes de Planos',
            Modules: 'Módulos',
            Roles: 'Perfis de Usuários',
            Users: 'Usuários',
            Profile: 'Meus dados',
            Mails: 'E-Mails',
            Popups: 'Popups',
            Notifications: 'Notificações',
        },
    },
}
